<template>
  <div class="pb-16 list-service-orders" :style="!client ? 'display: none;' : ''">
    <div style="padding-right: 20px; padding-left: 20px;">
      <v-card @click="viewServiceOrder(service)" v-for="service in list.items" :key="service.id" elevation="0" class="mt-5 mb-5" style="border: 1px solid #c5c5c5">
        <v-card-title class="pa-0">
          <v-list-item two-line >
            <v-list-item-content>
              <v-list-item-title style="text-transform: capitalize !important">
                <div v-if="service.client" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 5px">
                  {{ service.client.name }}
                </div>
                <div v-else>
                  Cliente não especificado
                </div>
              </v-list-item-title>
              <v-list-item-subtitle>
                <div v-if="service.vehicle" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 5px">
                  {{ service.vehicle.description }} {{ service.vehicle.year_model }}
                </div>
                <div v-else>
                  Veículo não especificado
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon v-if="service.vehicle">
              <img :src="service.vehicle.vehicle_plate_photo_url" style="height: 37px; margin-top: 10px;">
            </v-list-item-icon>

          </v-list-item>
        </v-card-title>
        <v-img :src="service.service_order_photos.length > 0 ? getServiceCoverPhoto(service.service_order_photos) : noPhotoImage" class="align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)" height="200px">
          <v-list-item class="px-3 white--text pb-3">
            {{ service.description }}
          </v-list-item>
        </v-img>
        <v-card-actions class="px-3">
          <div style="font-size: 14px; margin-top: 1px">
            <v-icon size="20" style="margin-right: 2px; margin-top: -2px">mdi-account-wrench</v-icon> {{ getLastResponsible(service) }}
          </div>
          <v-spacer></v-spacer>
          <v-chip v-if="getServiceStatus(service.status)" :color="getServiceStatus(service.status).color" class="white--text" label>{{ getServiceStatus(service.status).title }}</v-chip>
          <v-chip v-if="service.service_order_evaluations.length > 0" color="warning" class="white--text ml-2 px-2" label><v-icon size="20" class="mr-1">mdi-star</v-icon> {{ getServiceAverage(service.service_order_evaluations[0]) }}</v-chip>
        </v-card-actions>
      </v-card>

      <div v-if="list.items.length === 0 && !loading" class="text-center" style="margin-top: 50px; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; color: #666; font-size: 18px;">
        <v-icon size="100" color="#c5c5c5">mdi-car</v-icon>
        <div style="margin-top: 20px;">Nenhum Relatório de serviço encontrado</div>
      </div>
    </div>
    <div v-if="loading" style="padding-top: 20px;">
      <v-skeleton-loader
        class="mx-5"
        type="card"
        style="border: 1px solid #c5c5c5"
      ></v-skeleton-loader>
    </div>
    <div style="text-align: center;" class="mx-5 mb-6">
      <v-btn
        v-if="search.total_pages > 1 && !loading"
        @click="nextPageServices()"
        elevation="0"
        color="#e7e7e7"
        style="width: 100%"
      >
        <v-icon>mdi-chevron-double-down</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import Thumbor from 'thumbor-js-url-builder';

export default {
  name: 'ListServiceOrders',
  props: {
    client: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    clientId: null,
    search: {
      page: 1,
      total_pages: null,
    },
    list: {
      total: 0,
      items: [],
    }
  }),
  watch: {
    client: {
      handler(client) {
        this.clientId = client ? client.id : null;

        if (client) {
          this.refreshServiceOrders();
        } else {
          this.list.items = [];
        }
      },
    },
  },
  computed: {
    service_status_list () {
      return this.$store.getters['General/organization_status_list'];
    },
    isMotorcycle() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'MOTORCYCLE');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    isTractor() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'TRACTOR');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    isTruck() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'TRUCK');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    noPhotoImage() {
      /* eslint-disable global-require */
      if (this.isTractor) return require('@/assets/ads_nophoto_tractor.png');
      if (this.isMotorcycle) return require('@/assets/ads_nophoto_motorcycle.png');
      if (this.isTruck) return require('@/assets/ads_nophoto_truck.png');
      return require('@/assets/ads_nophoto.png');
      /* eslint-enable global-require */
    },
  },
  methods: {
    getServiceCoverPhoto(photos) {
      const searchPhotoMain = photos.find(photo => photo.tag === 'entry_medias_main')
      const searchPhotoFront = photos.find(photo => photo.tag === 'entry_medias_front')
      const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
      let returnPhoto = '';
      if (searchPhotoMain || searchPhotoFront) {
        returnPhoto = searchPhotoMain ? thumbor.setImagePath(searchPhotoMain.photo_url).resize(0, 348).buildUrl() : thumbor.setImagePath(searchPhotoFront.photo_url).resize(0, 348).buildUrl()
      } else if (photos[0]) {
        returnPhoto = thumbor.setImagePath(photos[0].photo_url).resize(0, 348).buildUrl()
      }
      return returnPhoto
    },
    getServiceStatus(statusRef) {
      const status = this.service_status_list.find(( status ) => status.code === statusRef);
      return status;
    },
    refreshServiceOrders() {
      this.loading = true;
      this.list.items = [];
      this.search.total_pages = null;
      this.search.page = 1;

      if (this.clientId) {
        this.getServiceOrders();
      }
    },
    getServiceOrders() {
      const self = this;
      self.loading = true;
      self.$http.get(`/service_orders/client/${self.clientId}`, {
        params: {
          page: self.search.page,
          size: 10,
        },
      }).then((response) => {
        self.list.total = response.data.totalItems;
        self.search.total_pages = response.data.totalPages;
        self.list.items = self.list.items.concat(response.data.rows);
        self.loading = false;
      }).catch(() => {
        self.loading = false;
      });
    },
    viewServiceOrder(service) {
      this.$emit('view', service);
    },
    nextPageServices() {
      const self = this;
      self.loading = true;
      self.search.page += 1;
      self.getServiceOrders();
    },
    getServiceAverage(evaluation) {
      return ((evaluation.attendance_note + evaluation.indication_note + evaluation.service_note) / 3).toFixed(2);
    },
    getLastResponsible(serviceOrder) {
      return serviceOrder.service_order_responsibles.length > 0
        ? serviceOrder.service_order_responsibles.slice(-1)[0].user.name.split(' ')[0]
        : serviceOrder.created_by_user.name.split(' ')[0];
    },
  },
};
</script>

<style lang="scss">
.v-chip {
  font-size: 12px !important;
  height: 31px !important;
}

.list-service-orders {

  .v-list-item {
    width: 100%;
    min-height: 60px;

    .v-list-item__content {
      padding: 5px 0;
    }

    .v-list-item__icon {
      margin: 0px !important;
      padding-top: 2px !important;
    }
  }
}
</style>
